import { NetworkConfiguration } from '../../network/networkConfriguation';
import { callAPI } from '../../network/networkConnection';
import { adminApiService } from '../admin/adminApiService';
import { fetchToken } from '../../lib/globalApiClient';

const getProducts = queryParams => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.PRODUCTS + queryParams, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};



const getHomeProducts = (options = {}) => {
  const params = new URLSearchParams();
  if (options.skipCache) params.set("skipCache", "1");
  if (options.forSellerDropshipping) params.set("forSellerDropshipping", "1");
  const qs = params.toString();
  const query = qs ? `?${qs}` : "";
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.HOME_PRODUCTS + query, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/** Sections only (no products) — for progressive loading: render sections first, then products per section */
const getHomeProductSections = () =>
  callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.HOME_PRODUCTS + '/sections', 'GET', {
    'Content-Type': 'application/json',
  });

/** Products for one section by fcId — call per section so each section can render when its data arrives */
const getHomeProductSectionProducts = (fcId) =>
  callAPI(
    process.env.REACT_APP_APIUrl + NetworkConfiguration.HOME_PRODUCTS + `/section/${encodeURIComponent(fcId)}/products`,
    'GET',
    { 'Content-Type': 'application/json' }
  );

const getProductById = id => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.PRODUCT_BY_ID + id, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getProductBySku = sku => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.PRODUCT_BY_SKU + sku, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};


const getProductsByOfferIds = payload => {
  return fetch(
    process.env.REACT_APP_APIUrl + "admin/products/by-offer-ids",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  ).then(res => res.json());
};




const getProductByOfferId = offerId => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + 'product/offer/' + offerId, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * Store product in DB when viewed on PDP (fire-and-forget).
 * Called after loading Alibaba product details.
 */
const storeProductFromAlibaba = (offerId, productData) =>
  callAPI(
    process.env.REACT_APP_APIUrl + 'product/store-from-alibaba',
    'POST',
    { 'Content-Type': 'application/json' },
    JSON.stringify({ offerId, productData })
  );

const submitProductInquiry = payload => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.PRODUCT_INQUIRY,
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify(payload)
    )
      .then(res => resolve(res))
      .catch(err => reject(err));
  });
};

//  fetch category approval + path for a specific SKU
const getSkuCategoryStatus = sku => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.SKU_CATEGORY_STATUS + sku + '/category-status', 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getCategoryContent = id => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.CATEGORY_CONTENT + id, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getProductsByTag = (keyword, queryParams = '') => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.PRODUCTS + `/tag/${keyword}${queryParams ? '?' + queryParams : ''}`, 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getHiddenTags = () => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + NetworkConfiguration.PRODUCTS + '/hidden-tags', 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getLocalShippingCost = (productOfferId, skuIdsNquantities = [], signal = null) => {
  return new Promise(async (resolve, reject) => {
    try {
      const baseUrl = process.env.REACT_APP_APIUrl1688;
      const token = await fetchToken();

      fetch(baseUrl.replace(/\/$/, '') + '/product-freight-cost', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Token': token
        },
        ...(signal ? { signal } : {}),
        body: JSON.stringify({
          offerId: productOfferId,
          toProvinceCode: '510000',
          toCityCode: '510000',
          toCountryCode: '510000',
          totalNum: skuIdsNquantities.reduce((acc, curr) => acc + curr.quantity, 0),
          logisticsSkuNumModels: skuIdsNquantities.map(variant => ({ skuId: variant.skuId, number: variant.quantity })),
        }),
      })
        .then(response => response.json())
        .then(async data => {
          // sometimes data.result.result is not present when data.result.success is false.
          const shippingCost = parseFloat(data.result?.result?.freight || 0);

          // Call cron-logs API to log this freight cost calculation
          // try {
          //   await adminApiService.post("/cron-logs", {
          //     jobType: 'product-freight-cost',
          //     jobId: `product-freight-cost-${productOfferId}-${skuIdsNquantities.map(s => s.skuId).join('-')}-${Date.now()}`,
          //     status: 'completed',
          //     triggeredBy: 'manual',
          //     domain: 'importerr.com',
          //     targetInfo: {
          //       offerId: productOfferId,
          //       skuIdsNquantities: skuIdsNquantities
          //     },
          //     stats: {
          //       totalProducts: skuIdsNquantities.length,
          //       updatedProducts: data.result?.success ? skuIdsNquantities.length : 0
          //     },
          //     logs: [{
          //       level: 'info',
          //       message: `Freight cost calculation completed for offerId: ${productOfferId}, skus: ${skuIdsNquantities.map(s => s.skuId).join(', ')}`,
          //       timestamp: new Date()
          //     }]
          //   });
          // } catch (logError) {
          //   console.error('Failed to log freight cost calculation:', logError);
          // }

          resolve({
            success: true,
            shippingCost: shippingCost,
            data: data,
          });
        })
        .catch(err => {
          reject(err);
        });
    } catch (tokenError) {
      reject(tokenError);
    }
  });
};

const calculatePricingAlgorithm = calculationData => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + 'product/pricing-algorithms/calculate',
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify(calculationData)
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// Batch calculate pricing for multiple products in one request
const calculatePricingAlgorithmBatch = items => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + 'product/pricing-algorithms/calculate-batch',
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify({ items })
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getPricingAlgorithm = async () => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + 'b2b/pricing-algorithm', 'GET', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const translateMandarinToEnglish = (translateData, to = 'en') => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + 'user/translate/bulk',
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify({ translateData, to })
    )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * Check if price logs exist for an offerId
 * Returns hasPriceLogs flag and variant prices from DB if available
 */
const checkPriceLogsForOffer = (offerId, signal = null) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    if (signal) {
      options.signal = signal;
    }

    fetch(process.env.REACT_APP_APIUrl + `product/alibaba/check-price-logs/${offerId}`, options)
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        if (err.name === 'AbortError') {
          resolve({ status: { code: 0 }, data: null });
        } else {
          reject(err);
        }
      });
  });
};

const generateDescription = (productId) => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + `admin/generate-description/${productId}`, 'PUT', {
      'Content-Type': 'application/json',
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const getFinalPrice = payload => {
  return new Promise((resolve, reject) => {
    callAPI(process.env.REACT_APP_APIUrl + 'admin/pricing-algorithms/get-final-price', 'POST', {
      'Content-Type': 'application/json'
    }, JSON.stringify(payload)).then(res => resolve(res)).catch(err => reject(err));
  })
}

export const ProductsApiService = {
  getProducts,
  getHomeProducts,
  getHomeProductSections,
  getHomeProductSectionProducts,
  getProductById,
  getProductBySku,
  getProductByOfferId,
  storeProductFromAlibaba,
  getSkuCategoryStatus,
  getCategoryContent,
  getLocalShippingCost,
  calculatePricingAlgorithm,
  calculatePricingAlgorithmBatch,
  getPricingAlgorithm,
  submitProductInquiry,
  translateMandarinToEnglish,
  getProductsByOfferIds,
  getProductsByTag,
  getHiddenTags,
  checkPriceLogsForOffer,
  generateDescription,
  getFinalPrice
};
